import { withStoreSelected } from '@fhs-legacy/frontend/src/components/store-selected';

import { OffersAndRewardsPage } from '../../../components/offers-and-rewards-page';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default withStoreSelected(OffersAndRewardsPage, { closeTo: '/menu' });
